export default __webpack_public_path__ + "static/media/img_publi1.169faacf.svg";